'use client';

import React from 'react';

const steps = [
  {
    num: '01',
    icon: '📋',
    title: 'Request Your Free Estimate',
    desc: 'Fill out our simple estimate form or call us directly. We\'ll gather details about your property and services needed.',
  },
  {
    num: '02',
    icon: '💬',
    title: 'Receive Honest Pricing',
    desc: 'We\'ll provide a clear, transparent quote with no hidden fees. You\'ll know exactly what you\'re paying before we start.',
  },
  {
    num: '03',
    icon: '📅',
    title: 'Schedule Your Appointment',
    desc: 'Pick a date and time that works for you. We offer flexible scheduling and always show up on time.',
  },
  {
    num: '04',
    icon: '✨',
    title: 'Enjoy a Beautiful Property',
    desc: 'Sit back while our team transforms your property. We\'re not done until you\'re 100% satisfied with the results.',
  },
];

export default function RGPSHowItWorks() {
  return (
    <section className="bg-white py-20 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-teal-light text-teal font-bold text-sm px-4 py-2 rounded-full mb-4">
            Simple Process
          </div>
          <h2 className="text-dark-text font-bold mb-4" style={{ fontSize: 'clamp(1.75rem, 4vw, 2.75rem)', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            How It Works
          </h2>
          <p className="text-gray-text text-lg max-w-2xl mx-auto">
            Getting your property cleaned is easy. Here's what to expect from start to finish.
          </p>
        </div>

        {/* Steps - Horizontal on desktop, vertical on mobile */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 relative">
          {/* Connector line - desktop only */}
          <div className="hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-teal via-teal to-teal-dark opacity-30" />

          {steps?.map((step, i) => (
            <div key={step?.num} className="relative flex flex-col items-center text-center group">
              {/* Step circle */}
              <div className="relative z-10 w-24 h-24 rounded-2xl bg-gradient-to-br from-teal to-teal-dark flex flex-col items-center justify-center shadow-teal mb-5 group-hover:scale-105 transition-transform">
                <div className="text-3xl mb-0.5">{step?.icon}</div>
                <div className="text-white/70 text-xs font-bold">{step?.num}</div>
              </div>

              {/* Arrow between steps - mobile */}
              {i < steps?.length - 1 && (
                <div className="md:hidden text-teal text-2xl mb-4">↓</div>
              )}

              <h3 className="font-bold text-dark-text text-base mb-2 leading-tight">
                {step?.title}
              </h3>
              <p className="text-gray-text text-sm leading-relaxed">
                {step?.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => document.querySelector('#estimate')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-2 bg-teal hover:bg-teal-dark text-white font-bold px-8 py-4 rounded-full shadow-teal transition-all hover:scale-105"
          >
            Start with a Free Estimate
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}
